(() => {
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.reviewClick) return;
      this.reviewIndex = Math.max(0, [...this.querySelectorAll('[data-review-slide]')].findIndex((slide) => !slide.hidden));
      this.reviewClick = (event) => {
        const target = event.target.closest('[data-review-index], [data-review-next]');
        if (!target || !this.contains(target)) return;
        const slides = [...this.querySelectorAll('[data-review-slide]')];
        if (!slides.length) return;
        const requested = target.hasAttribute('data-review-next') ? this.reviewIndex + 1 : Number(target.dataset.reviewIndex);
        if (!Number.isInteger(requested)) return;
        this.reviewIndex = ((requested % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, index) => { slide.hidden = index !== this.reviewIndex; });
        this.querySelectorAll('[data-review-index]').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.reviewIndex) === this.reviewIndex)));
        const status = this.querySelector('[data-review-status]');
        if (status) status.textContent = `${this.reviewIndex + 1} / ${slides.length}`;
      };
      this.addEventListener('click', this.reviewClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.reviewClick);
      this.reviewClick = null;
    }
  }
  class ReviewDeck extends HTMLElement {
    connectedCallback() {
      if (this.deckClick) return;
      const track = this.querySelector('[data-review-track]');
      if (!track) return;
      const slides = [...track.children];
      const current = () => Math.round(track.scrollLeft / (track.clientWidth + parseFloat(getComputedStyle(track).columnGap || '0')));
      this.deckClick = (event) => {
        const button = event.target.closest('[data-deck-prev], [data-deck-next]');
        if (!button || !this.contains(button)) return;
        const index = Math.max(0, Math.min(slides.length - 1, current() + (button.hasAttribute('data-deck-next') ? 1 : -1)));
        track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.deckScroll = () => {
        const status = this.querySelector('[data-deck-status]');
        if (status) status.textContent = `${Math.min(slides.length, Math.max(1, current() + 1))} / ${slides.length}`;
      };
      this.addEventListener('click', this.deckClick);
      track.addEventListener('scroll', this.deckScroll, {passive:true});
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.deckClick);
      this.querySelector('[data-review-track]')?.removeEventListener('scroll', this.deckScroll);
      this.deckClick = null;
    }
  }
  class NativePacks extends HTMLElement {
    connectedCallback() {
      if (this.root) return;
      this.root=this.closest('variant-selects');
      if (!this.root) return;
      try {this.records=JSON.parse(this.querySelector('script').textContent);} catch {return;}
      if (!Array.isArray(this.records)) return;
      this.schedule=()=>{
        if(this.pending)return;
        this.pending=true;
        this.frame=requestAnimationFrame(()=>{this.pending=false;this.refresh();});
      };
      this.root.addEventListener('change',this.schedule);
      this.observer=new MutationObserver(this.schedule);
      this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['checked','value']});
      this.refresh();
    }
    refresh() {
      const selected=[...this.root.querySelectorAll('[data-zyou-option-position]')].map(field=>field.querySelector('input:checked,select')?.value);
      const position=Number(this.dataset.position)-1;
      let hasSaving=false;
      this.root.querySelectorAll('[data-zyou-pack-value]').forEach(card=>{
        const row=this.records.find(record=>record.options.every((value,index)=>value===(index===position?card.dataset.zyouPackValue:selected[index])));
        if(row?.saving)hasSaving=true;
        for(const key of ['saving','unit','price']){
          const node=card.querySelector('[data-zyou-pack-'+key+']');
          if(!node)continue;
          const text=row?.[key]||(key==='price'?'—':'');
          if(node.textContent!==text)node.textContent=text;
          node.hidden=!text;
        }
      });
      const note=this.querySelector('[data-zyou-pack-note]');
      if(note)note.hidden=!hasSaving;
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change',this.schedule);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.root=null;this.pending=false;
    }
  }
  if (!customElements.get('zyou-native-packs')) customElements.define('zyou-native-packs',NativePacks);
  if (!customElements.get('zyou-review-carousel')) customElements.define('zyou-review-carousel', ReviewCarousel);
  if (!customElements.get('zyou-review-deck')) customElements.define('zyou-review-deck', ReviewDeck);
})();
